import PRODUCT_TYPE from 'Component/Product/Product.config';

import { NOT_APPLICABLE } from '../component/Matomo/Matomo.config';
import {
    getCategories, getPrice, getProductName, getVariant
} from './baseProduct.data';

const { configurable, simple } = PRODUCT_TYPE;

/** @namespace Bodymod/Matomo/EventData/ActionProduct/Data/getDimensionOne */
export const getDimensionOne = (type_id, product, configurableVariantIndex, mainSku) => {
    if (type_id === simple) {
        return NOT_APPLICABLE;
    }

    if (!configurableVariantIndex && mainSku && type_id === configurable) {
        const { variants } = product;
        return variants.find(({ sku }) => sku === mainSku).name;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(configurableVariantIndex)) {
        if (configurableVariantIndex === false) {
            return '';
        }
        const {
            name = ''
        } = product.variants[configurableVariantIndex];

        return name;
    }

    return NOT_APPLICABLE;
};

/** @namespace Bodymod/Matomo/EventData/ActionProduct/Data/getDimensionTwo */
export const getDimensionTwo = (type_id, product, configurableVariantIndex, inQtyChange = false, mainSku) => {
    if (type_id === simple) {
        return NOT_APPLICABLE;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(configurableVariantIndex)) {
        if (inQtyChange) {
            return mainSku;
        }
        if (configurableVariantIndex === false) {
            return '';
        }
        const {
            sku
        } = product.variants[configurableVariantIndex];

        return sku;
    }

    return null;
};

/** @namespace Bodymod/Matomo/EventData/ActionProduct/Data/productAddToCart */
export const productAddToCart = ({ product, quantity = 0, configurableVariantIndex = false }) => {
    const {
        type_id = simple, categories, sku, price = false
    } = product;

    return {
        name: getProductName(type_id, product),
        id: sku,
        price: getPrice(product, type_id, price),
        category: getCategories(categories),
        variant: getVariant(product, type_id, configurableVariantIndex),
        quantity
    };
};

/** @namespace Bodymod/Matomo/EventData/ActionProduct/Data/productQtyChangeData */
export const productQtyChangeData = ({ product: item }) => {
    const {
        qty = false, price, product: {
            type_id = simple, categories, sku: parentSku, name: parentName, variants
        }, product
    } = item;

    return {
        name: parentName,
        id: parentSku,
        price: (type_id === configurable)
            ? getPrice(variants[0], type_id, price, false)
            : getPrice(product, type_id, price, false),
        category: getCategories(categories),
        quantity: Math.abs(qty)
    };
};
